{
  "loadError": "Impossible de charger la configuration de la taxe de vente.",
  "source": {
    "own": "Les propres paramètres de cette organisation s'appliquent, à compter du",
    "inherited": "Les paramètres hérités de {{owner}} s'appliquent, à compter du"
  },
  "outcome": {
    "notCharged": "La TVP de la C.-B., la TVD du Manitoba et la TVP de la Saskatchewan ne sont pas facturées",
    "chargedNow": "La TVP de la C.-B., la TVD du Manitoba et la TVP de la Saskatchewan sont actuellement facturées",
    "basedOnOwnSetting": ", selon le paramètre « Autoriser la facturation de la TVP » sur la",
    "feeSettingsPage": "page des paramètres des frais",
    "basedOnOwnerSetting": ", selon le paramètre « Autoriser la facturation de la TVP » de {{owner}}.",
    "setUpCallToAction": "Choisissez vos taxes et enregistrez pour configurer cela.",
    "confirmCallToAction": "Enregistrez pour confirmer ou modifier cela."
  },
  "table": {
    "columns": {
      "province": "Province",
      "gst": "TPS",
      "hst": "TVH",
      "qst": "TVQ",
      "bcPst": "TVP C.-B.",
      "mbRst": "TVD Man.",
      "skPst": "TVP Sask."
    },
    "alwaysCharged": "Toujours facturé(e)",
    "charged": "Facturé(e)",
    "notCharged": "Non facturé(e)",
    "ratesNote": "Taux actuels, affichés à titre de référence. Les taux sont gérés par OneVest."
  },
  "readOnly": {
    "missingPermission": "Vous pouvez consulter les paramètres de la taxe de vente, mais pas les modifier."
  },
  "edit": {
    "save": "Enregistrer",
    "discard": "Abandonner"
  },
  "dateNote": {
    "today": "S'applique à l'ensemble du cycle de facturation actuel. Les factures déjà calculées ne changent pas."
  },
  "saveDialog": {
    "title": "Enregistrer les paramètres de la taxe de vente",
    "newRevision": "Ces paramètres prennent effet aujourd'hui, le {{date}}.",
    "correction": "Ceci remplace les paramètres déjà enregistrés pour aujourd'hui, le {{date}}. L'original est conservé à des fins d'audit.",
    "confirm": "Enregistrer",
    "cancel": "Annuler"
  },
  "saveNotice": {
    "conflictBeforeReload": "Quelqu'un d'autre a enregistré un paramètre pour cette date pendant que vous modifiiez.",
    "reload": "Recharger",
    "conflictAfterReload": "pour obtenir les dernières informations; vos choix sont conservés.",
    "reloaded": "Rechargé. Vos choix sont conservés; examinez-les et enregistrez à nouveau.",
    "reloadFailed": "Enregistré, mais les derniers paramètres n'ont pas pu être chargés."
  },
  "saveError": "Impossible d'enregistrer les paramètres de la taxe de vente.",
  "sync": {
    "applying": "Application de votre modification. Les frais utilisent le paramètre précédent jusqu'à ce que cela soit terminé.",
    "notReached": "Cette modification n'a pas encore atteint la facturation. Les frais utilisent le paramètre affiché ci-dessous jusqu'à ce que ce soit le cas. Si cela persiste, contactez le support.",
    "notReachedViewed": "Un récent changement d'héritage pour {{viewed}} n'a pas encore atteint la facturation. Les frais utilisent le paramètre affiché ci-dessous jusqu'à ce que ce soit le cas. Si cela persiste, contactez le support."
  },
  "inherit": {
    "label": "Hériter du parent",
    "stopped": "Héritage arrêté. Les propres paramètres de cette organisation s'appliquent à nouveau (ou l'ancien paramètre, si aucun n'a été enregistré).",
    "hint": {
      "unsavedChanges": "Enregistrez ou abandonnez vos modifications d'abord",
      "missingOrganizationWrite": "Vous avez besoin de la permission de modifier les paramètres de l'organisation pour changer cela.",
      "missingOrganizationRead": "Vous avez besoin de la permission de consulter les paramètres de l'organisation pour changer cela.",
      "orgFlagUnconfirmed": "Impossible de confirmer si cette organisation hérite de son parent."
    }
  }
}
